import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {usePremierVolumeSection} from './PremierVolumeSection.hook';
interface PremierVolumeSectionProps {
  metrics: Record<string, unknown>;
  currentUserCompetency: string;
  onShowInfoPopover: () => void;
  onShowReport: () => void;
}

export const PremierVolumeSection: React.FC<PremierVolumeSectionProps> = ({
  metrics,
  currentUserCompetency,
  onShowInfoPopover,
  onShowReport,
}) => {
  const {listItems, onInfoPress, onItemPress, ts} = usePremierVolumeSection({
    metrics,
    currentUserCompetency,
    onShowInfoPopover,
    onShowReport,
  });
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );

  // Logic for the Premier plus title
  const updateSectionTitle = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <MetricSection
      analyticsTitle="Projected Premier+ Volume"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Projected Premier Volume Section Information button',
      )}
      testID={MetricsSection.metricSectionProjectedPremierVolume}
      title={ts('heading', `Projected ${updateSectionTitle} Volume`)}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
    />
  );
};

export default PremierVolumeSection;
